/**
 * @generated SignedSource<<30dceeddb0738f93071e87a2e316f5d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PublishFolderItemDialog_folderItem$data = {
  readonly content: {
    readonly __typename: "Form";
    readonly id: string;
    readonly questions: ReadonlyArray<{
      readonly definition: {
        readonly __typename: string;
        readonly id: string;
        readonly options?: ReadonlyArray<{
          readonly text: string;
        }>;
      } | null;
      readonly id: string;
    }>;
  } | {
    readonly __typename: "Page";
    readonly data: UnknownJSON | null;
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly id: string;
  readonly name: string;
  readonly space: {
    readonly id: string;
  };
  readonly " $fragmentType": "PublishFolderItemDialog_folderItem";
};
export type PublishFolderItemDialog_folderItem$key = {
  readonly " $data"?: PublishFolderItemDialog_folderItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"PublishFolderItemDialog_folderItem">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomField__FieldOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PublishFolderItemDialog_folderItem",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "data",
              "storageKey": null
            }
          ],
          "type": "Page",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "FormQuestion",
              "kind": "LinkedField",
              "name": "questions",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "definition",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v0/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": (v2/*: any*/),
                      "type": "CustomField__Checkboxes",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v2/*: any*/),
                      "type": "CustomField__MultipleChoice",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Form",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "FolderItem",
  "abstractKey": null
};
})();

(node as any).hash = "6e07d6abb00c2dc3f786cab57045ae23";

export default node;
